import { submitForm } from "../../../stores/request";
import { useNavigate } from "react-router";
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Button,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import StyledHeader from "../../../components/StyledHeader/StyledHeader";
import { useCallback, useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import {
  ArticleOutlined,
  Input,
  CloudUploadOutlined,
  Upload,
} from "@mui/icons-material";
import FastaForm from "../../../components/FastaForm/FastaForm";
import { useSnackbar } from "notistack";
import checkFasta from "../../../utils/fastaValidator";

export default function ProteinPrediction(store) {
  // const [useCustomModel, setUseCustomModel] = useState(true);
  const gotoExample = () => {
    window.open("#/result?jobId=2023010264", "_blank");
  };
  const [defaultTask, setDefaultTask] = useState("");
  const [fasta, setFasta] = useState("");
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const [uploading, setUploading] = useState(false);
  const [inputFile, setInputFile] = useState(null);
  const [searching, setSearching] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const [resultData, setResultData] = useState({
    jobId: null,
    requestTime: "2021-09-23 14:36:13",
    status: "waiting",
  });
  const showModal = async (data) => {
    await setResultData({
      jobId: data.jobId,
      requestTime: data.requestTime,
      status: data.status,
    });
    await setIsModalVisible(true);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);

  const submit = async () => {
    let formData = new FormData();
    if (inputFile) {
      formData.append("dataFile", inputFile, inputFile.name);
      formData.append("dataStr", "");
    } else {
      if (fasta.length <= 0) {
        enqueueSnackbar("Please enter the sequence or select one FASTA file", {
          variant: "error",
        });
        return;
      }
      let check_fasta_format = checkFasta(
        fasta,
        enqueueSnackbar,
        "Protein",
        true
      );
      if (!check_fasta_format) {
        return false;
      }
      formData.append("dataStr", fasta);
    }

    if (email.length < 1) {
      enqueueSnackbar("Please input your e-mail", { variant: "error" });
      return;
    }
    if (defaultTask.length === 0) {
      // console.log(defaultTask, fasta);
      enqueueSnackbar("Please select one parameter", { variant: "error" });
      return;
    }

    //dataStr, dataFile, param, mail
    // formData.append(
    //   "dataStr",
    //   ">1a81_A\nSANHLPFFFGNITREEAEDYLVQGGMSDGLYLLRQSRNYLGGFALSVAHGRKAHHYTIERELNGTYAIAGGRTHASPADLCHYHSQESDGLVCLLKKPFNRPQGVQPKTGPFEDLKENLIREYVKQTWNLQGQALEQAIISQKPQLEKLIATTAHEKMPWFHGKISREESEQIVLIGSKTNGKFLIRARDNNGSYALCLLHEGKVLHYRIDKDKTGKLSIPEGKKFDTLWQLVEHYSYKADGLLRVLTVPCQKI"
    // );

    formData.append("type", 0);

    let predicttype = defaultTask;
    let submit_param = {
      type: "Binding",
      model: predicttype,
    };
    console.log(predicttype);
    submit_param = JSON.stringify(submit_param);
    formData.append("param", submit_param);
    formData.append("mail", email);
    enqueueSnackbar("uploading", { variant: "info" });

    let result = await submitForm(formData);
    console.log(result);
    if (result.success) {
      showModal(result.data);
    } else {
      enqueueSnackbar("failed", { variant: "error" });
    }
  };

  const resetData = useCallback(() => {
    setFasta("");
    setEmail("");
    setDefaultTask("");
  }, []);
  const handleOk = () => {
    setIsModalVisible(false);
    navigate("/tasks");
  };
  return (
    <Box>
      <Dialog open={isModalVisible} onClose={handleOk}>
        <DialogTitle>Your data has been uploaded successfully!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your request time is {resultData.requestTime} and your jobID is{" "}
            {resultData.requestTime.slice(0, 10).split("-").join("") +
              resultData.jobId}{" "}
            please wait.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk}>OK</Button>
        </DialogActions>
      </Dialog>
      <Paper elevation={3} sx={{ overflow: "hidden" }}>
        <StyledHeader icon={<Input />}>Binding task selection</StyledHeader>
        <Box padding={2}>
          <FormControl>
            <FormLabel>Select one parameter</FormLabel>
            <RadioGroup
              value={defaultTask}
              onChange={(e) => setDefaultTask(e.target.value)}
              row
            >
              <FormControlLabel
                value="1"
                control={<Radio />}
                label="DNA-Binding"
              />
              <FormControlLabel
                value="2"
                control={<Radio />}
                label="RNA-Binding"
              />
              <FormControlLabel
                value="3"
                control={<Radio />}
                label="Peptide-Binding"
              />
            </RadioGroup>

            <FormHelperText></FormHelperText>
          </FormControl>
          {/* </Collapse> */}
        </Box>
      </Paper>
      <Paper elevation={3} sx={{ overflow: "hidden", marginTop: 2 }}>
        <StyledHeader icon={<ArticleOutlined />}>
          Input target sequences
        </StyledHeader>

        <Box padding={2}>
          <FastaForm
            fasta={fasta}
            setFasta={setFasta}
            annotation={true}
            type="Binding"
            setInputFile={setInputFile}
          />
        </Box>
      </Paper>
      <Paper elevation={3} sx={{ marginTop: 2, overflow: "hidden" }}>
        <StyledHeader icon={<CloudUploadOutlined />}>Submission</StyledHeader>
        <Box margin={2}>
          <TextField
            value={email}
            onChange={({ target: { value } }) => {
              setEmail(value);
            }}
            label="E-mail address"
            fullWidth
            sx={{ mb: 2 }}
          />
          <Typography variant="body2" component="div" marginBottom={2}>
            Model training usually takes a long time, depending on the size of
            the data. Hence, we strongly recommend you to leave your e-mail
            address below so that you will be notified by email when the job is
            done.
          </Typography>
          <Box marginTop={2}>
            <LoadingButton
              onClick={submit}
              loading={uploading}
              variant="contained"
              loadingPosition="start"
              startIcon={<Upload />}
            >
              submit
            </LoadingButton>
            {/* <Button
              onClick={() => {}}
              variant="contained"
              color="secondary"
              sx={{ marginLeft: 1 }}
            >
              result example
            </Button> */}
            <Button
              onClick={gotoExample}
              variant="contained"
              color="secondary"
              sx={{ marginLeft: 1 }}
            >
              example result
            </Button>
            <Button
              onClick={resetData}
              color="error"
              variant="outlined"
              sx={{ marginLeft: 1 }}
            >
              reset
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
